const vP18338 = require("./121.js");
const vP183382 = require("./120.js");
function f2188(p18339) {
  this.mode = vP18338.KANJI;
  this.data = p18339;
}
f2188.getBitsLength = function (p18340) {
  return p18340 * 13;
};
f2188.prototype.getLength = function () {
  return this.data.length;
};
f2188.prototype.getBitsLength = function () {
  return f2188.getBitsLength(this.data.length);
};
f2188.prototype.write = function (p18341) {
  let v14080;
  for (v14080 = 0; v14080 < this.data.length; v14080++) {
    let v14081 = vP183382.toSJIS(this.data[v14080]);
    if (v14081 >= 33088 && v14081 <= 40956) {
      v14081 -= 33088;
    } else if (v14081 >= 57408 && v14081 <= 60351) {
      v14081 -= 49472;
    } else {
      throw new Error("Invalid SJIS character: " + this.data[v14080] + "\nMake sure your charset is UTF-8");
    }
    v14081 = (v14081 >>> 8 & 255) * 192 + (v14081 & 255);
    p18341.put(v14081, 13);
  }
};
module.exports = f2188;